// Import polyfill first to fix iOS Safari 14.4 URLSearchParams toString issues
import 'url-search-params-polyfill';

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import "./i18n";
import App from "./App.js";
import { initializeUrlToken } from "./utils/tokenManager.js";
import { applyAppTheme } from "./utils/sidebarTheme.js";

// Initialize URL token parsing before any other operations
// This ensures URL token takes priority over localStorage token
initializeUrlToken();

applyAppTheme();

// Initialize chunk error handler for handling 404s on missing assets

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

const root = createRoot(rootElement);

// Initialize global caret hiding for all multi-select inputs (current and future)
import { initializeHideMultiSelectCaret } from "./utils/hideMultiSelectCaret.js";
initializeHideMultiSelectCaret();

root.render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
